import React from 'react';

const TableHeaderWithSort = ({col, sort, title, onSortFunc}) => {

    const handleClick = () => {
        if (typeof onSortFunc === 'function') {
            onSortFunc({id: col.column.id, desc: sort.desc});
        }
    };

    const key = (col && col.column && col.column.id) ? 'header-' + col.column.id : 'header';
    let sortClass = '';
    if (col && col.column && col.column.id === sort.id) {
        sortClass = (sort.desc) ? ' desc' : ' asc';
    }

    return (
        <span id={key} className={`manual-sort${sortClass}`} onClick={handleClick}>
            {title}
        </span>
    )
};

export default TableHeaderWithSort;



// WEBPACK FOOTER //
// ./src/Fuse/components/TableHeaderWithSort.js